/* eslint-disable no-inline-styles/no-inline-styles */
import React from 'react';
import { Container, Row } from 'reactstrap';
import NavbarComponent from '../../Components/Header/Navbar';

const Content = () => {
    return (
        <React.Fragment>
            <Container className="page-content bg-body-bg" fluid>
                <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} />
                <Row className="justify-content-center  ">
                    <div className="d-flex flex-column align-items-center justify-content-center  p-5">
                        <div className="text-center ">
                            <h3 className="text-uppercase">Welcome to Landing Page 😎😎</h3>
                        </div>
                    </div>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default Content;
